import { Box, Dialog } from '@mui/material';
import { useSearchParams } from 'react-router';

import { FACTSHEET_PARAM_NAME, FACTSHEET_TAB_PARAM_NAME } from '@/pages/Facthsheets/constants';
import FactsheetView from '@/pages/Facthsheets/FactsheetView';

const FactsheetDialog = ({ code, open }: { code: string; open: boolean }) => {
  const [, setUrlSearchParams] = useSearchParams();
  return (
    <Dialog
      fullScreen
      open={open}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          backgroundColor: '#12163fcc'
        }}
      >
        <FactsheetView
          factsheetKeys={code}
          onDialogClose={() => {
            setUrlSearchParams(searchParams => {
              searchParams.delete(FACTSHEET_TAB_PARAM_NAME);
              searchParams.delete(FACTSHEET_PARAM_NAME);
              return searchParams;
            });
          }}
        />
      </Box>
    </Dialog>
  );
};

export default FactsheetDialog;
